import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Builder from './Builder/';
import Roles from './Roles';
import Stages from './Stages';
import Assets from './Assets';
import Transitions from './Transitions';
import Users from './Users';
import Settings from './Settings';
import Actions from './Actions';

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8'
  },
  indicator: {
    backgroundColor: '#1890ff'
  },
  flexContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
})(Tabs);

const AntTab = withStyles(theme => ({
  root: {
    paddingBottom: '6px',
    paddingTop: '10px',
    paddingLeft: '16px',
    textAlign: 'left',
    width: '174px',
    height: '40px',
    letterSpacing: '0.5px',
    lineHeight: '28px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px',
    textTransform: 'initial',
    fontFamily: 'Roboto-Light',
    '&:hover': {
      outline: 'none',
      opacity: 1
    },
    '&$selected': {
      outline: 'none',
      fontFamily: 'Roboto-Bold',
      fontSize: '20.6px',
      color: '#0747A6',
      letterSpacing: '0.25px',
      border: 'none'
    }
  },
  selected: {},
  wrapper: {
    display: 'inline-block'
  }
}))(props => <Tab disableRipple {...props} />);

function TabPanel (props) {
  // eslint-disable-next-line no-unused-vars
  const { children, value, index } = props;
  return <div hidden={value !== index}>{children}</div>;
}

const TopTab = () => {
  const [value, setValue] = React.useState('builder');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <AntTabs value={value} onChange={handleChange} aria-label='ant example'>
        <AntTab label='BUILDER' value='builder' />
        <AntTab label='ROLES' value='roles' />
        <AntTab label='STAGES' value='stages' />
        <AntTab label='ASSETS' value='assets' />
        <AntTab label='ACTIONS' value='actions' />
        <AntTab label='TRANSITIONS' value='transitions' />
        <AntTab label='USERS' value='users' />
        <AntTab label='SETTINGS' value='settings' />
      </AntTabs>
      <TabPanel value={value} index='builder'>
        <Builder />
      </TabPanel>
      <TabPanel value={value} index='roles'>
        <Roles />
      </TabPanel>
      <TabPanel value={value} index='stages'>
        <Stages />
      </TabPanel>
      <TabPanel value={value} index='assets'>
        <Assets />
      </TabPanel>
      <TabPanel value={value} index='actions'>
        <Actions />
      </TabPanel>
      <TabPanel value={value} index='transitions'>
        <Transitions />
      </TabPanel>
      <TabPanel value={value} index='users'>
        <Users />
      </TabPanel>
      <TabPanel value={value} index='settings'>
        <Settings />
      </TabPanel>
    </>
  );
};

export default TopTab;
